'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

require('../stylesheets/global.scss');

var _utils = require('helpers/utils');

var _components = require('components');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

var _audiences = require('redux/modules/audiences');

var _events = require('redux/modules/events');

var _organizations = require('redux/modules/organizations');

var _regions = require('redux/modules/regions');

var _tags = require('redux/modules/tags');

var _types = require('redux/modules/types');

var _venues = require('redux/modules/venues');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch, location) {
  var entityTypes = [{
    areTopsLoaded: _audiences.areTopsLoaded,
    isLoaded: _audiences.isLoaded,
    isMenuProvided: _audiences.isMenuProvided,
    isMenuRequired: _audiences.isMenuRequired,
    load: _audiences.load,
    loadTops: _audiences.loadTops,
    name: 'audiences',
    setMenu: _audiences.setMenu,
    setSelected: _audiences.setSelected
  }, {
    areTopsLoaded: _organizations.areTopsLoaded,
    isLoaded: _organizations.isLoaded,
    isMenuProvided: _organizations.isMenuProvided,
    isMenuRequired: _organizations.isMenuRequired,
    load: _organizations.load,
    loadTops: _organizations.loadTops,
    name: 'organizations',
    setMenu: _organizations.setMenu,
    setSelected: _organizations.setSelected
  }, {
    areTopsLoaded: _regions.areTopsLoaded,
    isLoaded: _regions.isLoaded,
    isMenuProvided: _regions.isMenuProvided,
    isMenuRequired: _regions.isMenuRequired,
    load: _regions.load,
    loadTops: _regions.loadTops,
    name: 'regions',
    setMenu: _regions.setMenu,
    setSelected: _regions.setSelected
  }, {
    areTopsLoaded: _tags.areTopsLoaded,
    isLoaded: _tags.isLoaded,
    isMenuProvided: _tags.isMenuProvided,
    isMenuRequired: _tags.isMenuRequired,
    load: _tags.load,
    loadTops: _tags.loadTops,
    name: 'tags',
    setMenu: _tags.setMenu,
    setSelected: _tags.setSelected
  }, {
    areTopsLoaded: _types.areTopsLoaded,
    isLoaded: _types.isLoaded,
    isMenuProvided: _types.isMenuProvided,
    isMenuRequired: _types.isMenuRequired,
    load: _types.load,
    loadTops: _types.loadTops,
    name: 'types',
    setMenu: _types.setMenu,
    setSelected: _types.setSelected
  }, {
    areTopsLoaded: _venues.areTopsLoaded,
    isLoaded: _venues.isLoaded,
    isMenuProvided: _venues.isMenuProvided,
    isMenuRequired: _venues.isMenuRequired,
    load: _venues.load,
    loadTops: _venues.loadTops,
    name: 'venues',
    setMenu: _venues.setMenu,
    setSelected: _venues.setSelected
  }];

  var topsPromises = [];
  var missingMenuTypes = entityTypes.filter(function (type) {
    return type.isMenuRequired() && !type.isMenuProvided();
  });
  missingMenuTypes.forEach(function (type) {
    if (!type.areTopsLoaded(getState())) {
      topsPromises.push(dispatch(type.loadTops()));
    }
  });

  return _promise2.default.all(topsPromises).then(function () {
    var loadPromises = [];
    entityTypes.forEach(function (type) {
      if (!type.isLoaded(getState())) {
        var ids = (0, _utils.splitIdsList)(location.query[type.name]).concat(getState()[type.name].config.menu || []).filter(function (id) {
          return !getState()[type.name][type.name].find(function (item) {
            return item.id === id;
          });
        });

        if (ids.length > 0) {
          loadPromises.push(dispatch(type.load(ids)));
        }
      }
    });

    return _promise2.default.all(loadPromises).then(function () {
      if (!!location.query.range) {
        var range = (0, _utils.parseRange)(location.query.range);
        dispatch((0, _events.selectRange)(range));
      }

      entityTypes.forEach(function (type) {
        if (type.isMenuRequired()) {
          if (type.isMenuProvided()) {
            dispatch(type.setMenu(getState()[type.name].config.menu));
          } else {
            dispatch(type.setMenu(getState()[type.name].tops.items.map(function (item) {
              return item.id;
            })));
          }
        }

        dispatch(type.setSelected(location.query[type.name]));
      });
    });
  });
}

var AppContainer = (_dec = (0, _connectData2.default)(fetchData), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AppContainer, _Component);

  function AppContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppContainer.__proto__ || (0, _getPrototypeOf2.default)(AppContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppContainer, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // TODO: get this info from redux router
      var locale = 'fr';
      var calendar = require('./../locales/fr/calendar.js');
      var phrases = require('./../locales/fr/home.js');

      (0, _assign2.default)(phrases, require('./../locales/' + locale + '/event.js'));

      // Setup momentjs
      _moment2.default.updateLocale(locale, calendar);

      return {
        polyglot: new _nodePolyglot2.default({
          locale: locale,
          phrases: phrases
        }),
        moment: _moment2.default
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.logPageView();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.logPageView();
    }
  }, {
    key: 'setPageTitle',
    value: function setPageTitle(pageTitle) {
      this.setState({
        title: pageTitle
      });
    }
  }, {
    key: 'logPageView',
    value: function logPageView() {
      if (typeof window !== 'undefined' && !!window.ga) {
        window.ga('send', 'pageview');
      }
    }
  }, {
    key: 'toggleSitesOverlay',
    value: function toggleSitesOverlay(event) {
      event.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, _config2.default.app),
        _react2.default.createElement(_components.App, { children: this.props.children, setPageTitle: this.setPageTitle.bind(this) })
      );
    }
  }]);
  return AppContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _class2.childContextTypes = {
  polyglot: _react.PropTypes.object,
  moment: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = AppContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AppContainer.js
// module id = 1173
// module chunks = 0